import React from 'react';
import { SecureNavigationBeacon } from '@trp-ii-ii-component-library/ii-components';

type Props = {
  logoutCallback: Function;
};

const AppHeader: React.FC<Props> = ({ logoutCallback }) => {
  return (
    <header>
      <SecureNavigationBeacon
        authentication={{
          authorization: {
            isCustomerWebView: false,
            isAuthenticated: true,
            isAuthorized: true
          },
          user: {}
        }}
        data={{
          isLoading: false,
          showLoadingBar: false,
          adoptNewLoading: false,
          loadingBarCustomData: {},
          showMainMenu: false,
          showContextualNav: true,
          showMyProfile: false
        }}
      />
    </header>
  );
};

export default AppHeader;
